export default __webpack_public_path__ + "static/media/sword_alone.80a863f1.png";